import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sub-management-office-list" }
const _hoisted_2 = {
  key: 0,
  class: "list-loading"
}
const _hoisted_3 = { class: "list list-scrollbar" }
const _hoisted_4 = { class: "table-header-row" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = {
  key: 0,
  class: "d-inline-block"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "column-space fix-td" }
const _hoisted_11 = { class: "column-space" }
const _hoisted_12 = { class: "column-space" }
const _hoisted_13 = { class: "column-space" }
const _hoisted_14 = { class: "column-space" }
const _hoisted_15 = { class: "column-space" }
const _hoisted_16 = { class: "column-space" }
const _hoisted_17 = { class: "column-space" }
const _hoisted_18 = { class: "column-space" }
const _hoisted_19 = { class: "column-space" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { colspan: "9" }

import StatusChangeConfirmModal from "@/components/Common/StatusCangeConfirmModal.vue"
import ResizableList from '@/components/ResizableList.vue';
import subManagementOfficeType from "@/types/subManagementOffice"
import { formatDate } from "@/services/functions"
import { reactive } from 'vue'
import i18n from '@/lang/i18n'
import EditLinkIcon from "@/components/Common/EditLinkIcon.vue"
import DisplayFullnameFromUpdatedBy from '@/components/Common/DisplayFullnameFromUpdatedBy.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SubManagementList',
  props: {
    subManagementOffices: {},
    changeStatusAuthority: { type: Boolean },
    isLoading: { type: Boolean },
    updatingStatus: { type: Boolean }
  },
  emits: ['changeSortOrder', 'changeStatus'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit
const HEADER = ([
  i18n.global.t('pages.subManagementOffice.id'),
  i18n.global.t('pages.subManagementOffice.companyName'),
  i18n.global.t('pages.subManagementOffice.contactName'),
  i18n.global.t('pages.subManagementOffice.dksNoInitial'),
  i18n.global.t('pages.subManagementOffice.telephoneNumber'),
  i18n.global.t('pages.subManagementOffice.comment'),
  i18n.global.t('pages.subManagementOffice.status'),
  i18n.global.t('pages.subManagementOffice.updatedAt'),
  i18n.global.t('pages.subManagementOffice.updatedBy'),
  i18n.global.t('pages.subManagementOffice.list.edit')
])
const SORTABLE_ITEMS: any = ({
  [i18n.global.t('pages.subManagementOffice.id')]: 'id',
  [i18n.global.t('pages.subManagementOffice.companyName')]: 'company_name',
  [i18n.global.t('pages.subManagementOffice.contactName')]: 'contact_name',
  [i18n.global.t('pages.subManagementOffice.dksNoInitial')]: 'dks_no_initial',
  [i18n.global.t('pages.subManagementOffice.telephoneNumber')]: 'telephone_number',
  [i18n.global.t('pages.subManagementOffice.status')]: 'status',
  [i18n.global.t('pages.subManagementOffice.updatedAt')]: 'updated_at',
  [i18n.global.t('pages.subManagementOffice.updatedBy')]: 'updated_by'
})
const currentSort = reactive({
  item: 'id',
  type: i18n.global.t('pages.common.sortType.asc')
})
const sortTypes = reactive([
  i18n.global.t('pages.common.sortType.asc'),
  i18n.global.t('pages.common.sortType.desc')
])
const itemName = i18n.global.t('pages.subManagementOffice.title.title')


function datetimeFormat (datetime: string) {
  const d = new Date(datetime)
  return formatDate(d)
}

function commnet (commnet: string | null) {
  if (commnet) return i18n.global.t('pages.subManagementOffice.list.existComment')
  return i18n.global.t('pages.subManagementOffice.list.notExistComment')
}

function emitChangeSortOrder (sortItem: string, sortType: string | null = null) {
  if (!sortableItem(sortItem)) return
  const item = SORTABLE_ITEMS[sortItem]
  if (sortType) {
    currentSort.type = sortType
  } else {
    if (currentSort.item == item) {
      const type = sortTypes.find(type => type != currentSort.type)
      currentSort.type = type ?? ""
    } else {
      currentSort.type = sortTypes[0]
    }
  }
  currentSort.item = item
  emits('changeSortOrder', currentSort.item, currentSort.type)
}

function sortableItem (itemName: string) {
  return Object.keys(SORTABLE_ITEMS).includes(itemName)
}

function addClassIfSortable (itemName: string) {
  if (!sortableItem(itemName)) return
  return 'sort-icon pl-2 pt-1';
}

function highLightIfCurrentSort (item: string, type: string) {
  if (currentSort.item != SORTABLE_ITEMS[item] || currentSort.type != type) return
  return 'fw-bold'
}

function applyLeftClass (index: number) {
  if (index == 0) return 'start-0'
}

function emitChangeStatus (params: {id: number, status: number}, key: string) {
  emits('changeStatus', params, key)
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(ResizableList, { scrollAreaSelector: ".list" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_4, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(HEADER, (item, index) => {
                    return _createElementVNode("th", {
                      key: index,
                      class: _normalizeClass(["table-header column-space", applyLeftClass(index)])
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        (sortableItem(item))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["nc-icon nc-stre-up sort-icon d-block", highLightIfCurrentSort(item, sortTypes[0])]),
                                onClick: ($event: any) => (emitChangeSortOrder(item, sortTypes[0]))
                              }, null, 10, _hoisted_7),
                              _createElementVNode("div", {
                                class: _normalizeClass(["nc-icon nc-stre-down sort-icon d-block", highLightIfCurrentSort(item, sortTypes[1])]),
                                onClick: ($event: any) => (emitChangeSortOrder(item, sortTypes[1]))
                              }, null, 10, _hoisted_8)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: _normalizeClass(addClassIfSortable(item)),
                          onClick: ($event: any) => (emitChangeSortOrder(item))
                        }, _toDisplayString(item), 11, _hoisted_9)
                      ])
                    ], 2)
                  }), 64))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (__props.subManagementOffices?.length != 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.subManagementOffices, (subManagementOffice) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: subManagementOffice.id
                      }, [
                        _createElementVNode("td", _hoisted_10, _toDisplayString(subManagementOffice.id), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(subManagementOffice.company_name), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(subManagementOffice.contact_name ? subManagementOffice.contact_name : ''), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(subManagementOffice.dks_no_initial), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(subManagementOffice.telephone_number), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(commnet(subManagementOffice.comment)), 1),
                        _createElementVNode("td", _hoisted_16, [
                          _createVNode(StatusChangeConfirmModal, {
                            item: subManagementOffice,
                            itemName: _unref(itemName),
                            updatableStatusButton: __props.changeStatusAuthority,
                            updatingStatus: __props.updatingStatus,
                            onSubmit: emitChangeStatus
                          }, null, 8, ["item", "itemName", "updatableStatusButton", "updatingStatus"])
                        ]),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(datetimeFormat(subManagementOffice.updated_at)), 1),
                        _createElementVNode("td", _hoisted_18, [
                          _createVNode(DisplayFullnameFromUpdatedBy, {
                            updatedBy: subManagementOffice.updated_by
                          }, null, 8, ["updatedBy"])
                        ]),
                        _createElementVNode("td", _hoisted_19, [
                          _createVNode(EditLinkIcon, {
                            name: 'subManagementOfficeForm',
                            id: subManagementOffice.id
                          }, null, 8, ["id"])
                        ])
                      ]))
                    }), 128))
                  : (__props.subManagementOffices?.length == 0 && !props.isLoading)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                        _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(i18n).global.t('pages.common.list.noData')), 1)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})